// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const ST_TITULO_FIN = {
  Rascunho: 'ST_TITULO_FIN6',
  Aberto: 'ST_TITULO_FIN1',
  PagoParcial: 'ST_TITULO_FIN2',
  Baixado: 'ST_TITULO_FIN3',
  Cancelado: 'ST_TITULO_FIN4',
  PrestacaoConcluida: 'ST_TITULO_FIN5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    ST_TITULO_FIN6: 1,
    ST_TITULO_FIN1: 2,
    ST_TITULO_FIN2: 3,
    ST_TITULO_FIN3: 4,
    ST_TITULO_FIN4: 5,
    ST_TITULO_FIN5: 6
  }
}
